module.exports = __webpack_public_path__ + "block-3-0.75x-27ded3feb12754fdca1f5200f6dc6bf0.webp";